import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { IDetalharPrescricao } from "../../../../../../../types/api/receituarioAgronomico/detalhar-prescricoes";
import { TableSimples } from "../../../../../../../components/BasicComponents/DisplayDados/TableSimples";

export default function DialogPragas({
    open,
    onClose,
    pragas
}: DialogPragasProps) {

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
        >
            <DialogTitle>Detalhes das Pragas</DialogTitle>
            <DialogContent>
                <TableSimples
                    headers={[
                        { label: "Nome" },
                        { label: "Nome Científico", numeric: true }
                    ]}
                    rows={pragas.map(row => ({
                        columns: [
                            { value: row.nome_popular },
                            { value: row.nome_cientifico, numeric: true }
                        ]
                    }))}
                    total={
                        pragas.length > 0
                            ? {
                                label: '',
                                value: `+ ${pragas.length} registro(s)`,
                                monetary: false
                            }
                            : undefined
                    }
                />
            </DialogContent>

            <DialogActions>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogPragasProps {
    open: boolean;
    pragas: IDetalharPrescricao['pragas'];
    onClose: () => void;
}
